import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/superscript/superscriptediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AttributeCommand from "../attributecommand";
var SUPERSCRIPT = 'superscript';
/**
 * The superscript editing feature.
 *
 * It registers the `super` command and introduces the `super` attribute in the model which renders to the view
 * as a `<super>` element.
 *
 * @extends module:core/plugin~Plugin
 */

var SuperscriptEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(SuperscriptEditing, _Plugin);

  var _super = _createSuper(SuperscriptEditing);

  function SuperscriptEditing() {
    _classCallCheck(this, SuperscriptEditing);

    return _super.apply(this, arguments);
  }

  _createClass(SuperscriptEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor; // Allow super attribute on text nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: SUPERSCRIPT
      });
      editor.model.schema.setAttributeProperties(SUPERSCRIPT, {
        isFormatting: true,
        copyOnEnter: true
      }); // Build converter from model to view for data and editing pipelines.

      editor.conversion.attributeToElement({
        model: SUPERSCRIPT,
        view: 'sup',
        upcastAlso: [{
          styles: {
            'vertical-align': 'super'
          }
        }]
      }); // Create super command.

      editor.commands.add(SUPERSCRIPT, new AttributeCommand(editor, SUPERSCRIPT));
    }
  }]);

  return SuperscriptEditing;
}(Plugin);

export { SuperscriptEditing as default };